import { ISkillResource } from "../../skills";
import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ISkillTranslation } from "../types";

export interface ISkillTranslationQueryParameters {
    skill?: RelationalValue<ISkillResource>;
    locale: string;
}

export type ISkillTranslationQueryResult = ISkillTranslation;

export const skillTranslationQuery: IApiQueryFunction<ISkillTranslationQueryParameters> = ({ skill, locale }) => {
    if (!skill) {
        return;
    }

    return {
        method: "GET",
        url: `/skills/${mapRelationalValue(skill)}/translations/${locale}`,
    };
};

export const useSkillTranslationQuery = createApiQueryHook<
    ISkillTranslationQueryParameters,
    ISkillTranslationQueryResult
>(skillTranslationQuery);
